import React, { useState } from 'react';
import styles from '../../src/assets/sass/options.module.sass';
import { CAMERA_PROPERTIES_STEP } from './helper/constants';
import { DB } from '../utils/dbApis';
import { SuccessToastMessage } from '../utils/jsHelper';

const CameraSection = ({ currentProduct, setCurrentProduct }) => {
  const [cameraSection, setCameraSection] = useState(false);
  const [cameraSectionInit, setCameraSectionInit] = useState(false);

  const handleArrayChange = (arrayName, index, value) => {
    setCurrentProduct((prevData) => {
      const updatedArray = [...prevData[arrayName]];
      updatedArray[index] = value;
      return { ...prevData, [arrayName]: updatedArray };
    });
  };
  // console.log(data,"data")
  async function handleUpdateCamera() {
    try {
      const { data, error } = await DB.from('Scene_Data')
        .update({
          id: currentProduct?.id,
          title: currentProduct?.title,
          uuid: currentProduct?.uuid,

          cameraMinMaxZoomDistance: [
            currentProduct?.cameraMinMaxZoomDistance[0],
            currentProduct?.cameraMinMaxZoomDistance[1],
          ],
          cameraTargetPos: [
            currentProduct?.cameraTargetPos[0],
            currentProduct?.cameraTargetPos[1],
            currentProduct?.cameraTargetPos[2],
          ],
        })
        .eq('id', currentProduct?.id)
        .select();

      if (error === null) {
        SuccessToastMessage('Camera Updated Successfully!!!');
      } else {
        console.log('Error occurred:', error);
      }
    } catch (err) {
      console.error('Unexpected error occurred:', err);
    }
  }

  async function handleUpdateCameraInit() {
    try {
      const { data, error } = await DB.from('Scene_Data')
        .update({
          id: currentProduct?.id,
          title: currentProduct?.title,
          uuid: currentProduct?.uuid,
          cameraInitPos: [
            currentProduct?.cameraInitPos[0],
            currentProduct?.cameraInitPos[1],
            currentProduct?.cameraInitPos[2],
          ],
        })
        .eq('id', currentProduct?.id)
        .select();

      if (error === null) {
        SuccessToastMessage('Camera Init Updated Successfully!!!');
      } else {
        console.log('Error occurred:', error);
      }
    } catch (err) {
      console.error('Unexpected error occurred:', err);
    }
  }

  return (
    <>
      {currentProduct && (
        <div style={{ marginBottom: 5 }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span
              className={styles.accordianIcon}
              style={{ transform: cameraSection ? 'rotate(90deg)' : 'none' }}
            ></span>
            <span
              className={styles.accordianTitle}
              onClick={() => {
                setCameraSection(!cameraSection);
              }}
            >
              Camera
            </span>
            <span
              className={styles.saveButton}
              onClick={() => handleUpdateCamera()}
            >
              Save
            </span>
          </div>
          {cameraSection && (
            <>
              <div style={{ padding: 2, marginLeft: 5 }}>
                <label className={styles.accordianLabel} htmlFor="numberInput">
                  Min zoom:
                </label>
                <input
                  type="number"
                  id="numberInput"
                  value={currentProduct?.cameraMinMaxZoomDistance[0]}
                  step={CAMERA_PROPERTIES_STEP}
                  onChange={(e) =>
                    handleArrayChange(
                      'cameraMinMaxZoomDistance',
                      0,
                      Number(e.target.value),
                    )
                  }
                />
              </div>
              <div style={{ padding: 2, marginLeft: 5 }}>
                <label className={styles.accordianLabel} htmlFor="numberInput">
                  Max zoom:
                </label>
                <input
                  type="number"
                  id="numberInput"
                  step={CAMERA_PROPERTIES_STEP}
                  value={currentProduct?.cameraMinMaxZoomDistance[1]}
                  onChange={(e) =>
                    handleArrayChange(
                      'cameraMinMaxZoomDistance',
                      1,
                      Number(e.target.value),
                    )
                  }
                />
              </div>

              <div style={{ padding: 2, marginLeft: 5 }}>
                <label className={styles.accordianLabel} htmlFor="numberInput">
                  Target X:
                </label>
                <input
                  type="number"
                  id="numberInput"
                  step={CAMERA_PROPERTIES_STEP}
                  value={currentProduct?.cameraTargetPos[0]}
                  onChange={(e) =>
                    handleArrayChange(
                      'cameraTargetPos',
                      0,
                      Number(e.target.value),
                    )
                  }
                />
              </div>
              <div style={{ padding: 2, marginLeft: 5 }}>
                <label className={styles.accordianLabel} htmlFor="numberInput">
                  Target Y:
                </label>
                <input
                  type="number"
                  id="numberInput"
                  step={CAMERA_PROPERTIES_STEP}
                  value={currentProduct?.cameraTargetPos[1]}
                  onChange={(e) =>
                    handleArrayChange(
                      'cameraTargetPos',
                      1,
                      Number(e.target.value),
                    )
                  }
                />
              </div>
              <div style={{ padding: 2, marginLeft: 5 }}>
                <label className={styles.accordianLabel} htmlFor="numberInput">
                  Target Z:
                </label>
                <input
                  type="number"
                  id="numberInput"
                  step={CAMERA_PROPERTIES_STEP}
                  value={currentProduct?.cameraTargetPos[2]}
                  onChange={(e) =>
                    handleArrayChange(
                      'cameraTargetPos',
                      2,
                      Number(e.target.value),
                    )
                  }
                />
              </div>
            </>
          )}
        </div>
      )}
      {currentProduct && (
        <div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span
              className={styles.accordianIcon}
              style={{ transform: cameraSection ? 'rotate(90deg)' : 'none' }}
            ></span>
            <span
              className={styles.accordianTitle}
              onClick={() => {
                setCameraSectionInit(!cameraSectionInit);
              }}
            >
              Camera Init
            </span>
            <span
              className={styles.saveButton}
              onClick={() => handleUpdateCameraInit()}
            >
              Save
            </span>
          </div>
          {cameraSectionInit && (
            <>
              <div style={{ padding: 2, marginLeft: 5 }}>
                <label className={styles.accordianLabel} htmlFor="numberInput">
                  Init X:
                </label>
                <input
                  type="number"
                  id="numberInput"
                  step={CAMERA_PROPERTIES_STEP}
                  value={currentProduct?.cameraInitPos[0]}
                  onChange={(e) =>
                    handleArrayChange(
                      'cameraInitPos',
                      0,
                      Number(e.target.value),
                    )
                  }
                />
              </div>
              <div style={{ padding: 2, marginLeft: 5 }}>
                <label className={styles.accordianLabel} htmlFor="numberInput">
                  Init Y:
                </label>
                <input
                  type="number"
                  id="numberInput"
                  step={CAMERA_PROPERTIES_STEP}
                  value={currentProduct?.cameraInitPos[1]}
                  onChange={(e) =>
                    handleArrayChange(
                      'cameraInitPos',
                      1,
                      Number(e.target.value),
                    )
                  }
                />
              </div>
              <div style={{ padding: 2, marginLeft: 5 }}>
                <label className={styles.accordianLabel} htmlFor="numberInput">
                  Init Z:
                </label>
                <input
                  type="number"
                  id="numberInput"
                  step={CAMERA_PROPERTIES_STEP}
                  value={currentProduct?.cameraInitPos[2]}
                  onChange={(e) =>
                    handleArrayChange(
                      'cameraInitPos',
                      2,
                      Number(e.target.value),
                    )
                  }
                />
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default CameraSection;
